<template>
	<tr @click="redirectToShowPage" class="matter-record">
		<td class="py-1">{{ matter.quotation_number }}</td>
		<td class="py-1">{{ matter.quotation_sub_number }}</td>
		<td class="py-1">{{ matter.name }}</td>
		<td class="py-1">{{ matter.created_at | dateFormatter }}</td>
		<td class="py-1">
			{{ matter.regular_customer_company ? matter.regular_customer_company.customer_code : null }}
		</td>
		<td class="py-1">
			{{ matter.regular_customer_company ? matter.regular_customer_company.name : null }}
		</td>
		<td class="py-1">
			{{
				matter.regular_customer_company_person ? matter.regular_customer_company_person.name : null
			}}
		</td>
		<td class="py-1">
			{{ matter.customer_company ? matter.customer_company.name : null }}
		</td>
		<td class="py-1">
			<table width="100%" ref="productsCell">
				<tbody width="100%">
					<tr v-for="(product, i) in matter.products" :key="i" class="matter-product-record">
						<td width="80%">{{ product.name }}</td>
						<td width="20%">{{ product.quantity }}個</td>
					</tr>
				</tbody>
			</table>
		</td>
		<td class="py-1">{{ regularlySold }}</td>
		<td class="py-1">{{ Number(matter.quotation_amount).toLocaleString() }}</td>
		<td style="overflow: scroll">
			<p v-text="matter.points" class="point-cell my-1" :style="maxHeight"></p>
		</td>
		<td class="py-1">{{ matter.quotation_deadline | filterYear }}</td>
		<td class="py-1">{{ matter.quotation_deadline | filterMonth }}</td>
		<td class="py-1">{{ matter.quotation_deadline | filterDay }}</td>
		<td class="py-1">{{ matter.product_category.name }}</td>
		<td class="py-1">{{ matter.product_sub_category.name }}</td>
		<td class="py-1">{{ matter.situation }}</td>
		<td class="py-1">{{ matter.competitor }}</td>
		<td class="py-1">{{ contract }}</td>
		<td class="py-1">{{ matter.planned_order_date | dateFormatter }}</td>
		<td class="py-1">
			{{ matter.company_period ? matter.company_period.title : null }}
		</td>
		<td class="py-1">{{ matter.lost_to }}</td>
		<td class="py-1">{{ matter.costing_request_date | dateFormatter }}</td>
		<td class="py-1">{{ matter.cost_receipt_date | dateFormatter }}</td>
		<td class="py-1">{{ Number(matter.total_cost).toLocaleString() }}</td>
		<td class="py-1">{{ Number(matter.ordered_amount).toLocaleString() }}</td>
		<td class="py-1">{{ matter.order_profit_ratio }}</td>
		<td class="py-1">{{ Number(matter.lost_amount).toLocaleString() }}</td>
		<td class="py-1">{{ matter.lost_profit_ratio }}</td>
		<td class="py-1">{{ matter.updated_at | dateFormatter }}</td>
		<td class="py-1" v-for="(data, i) in matter_keys" v-text="metaText(data)" :key="i">
			{{ matter.meta_data }}
		</td>
	</tr>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	components: {},
	props: {
		current_company_name: {
			type: String,
		},
		matter: {
			type: Object,
			required: false,
			default: () => {},
		},
		matter_keys: {
			type: Array,
			required: false,
			default: () => {},
		},
	},
	data() {
		return {
			productTableHeight: null,
		}
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter: function (time) {
			if (!time) return ""
			return moment(time).format("HH:mm")
		},
		filterYear: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY")
		},
		filterMonth: function (date) {
			if (!date) return ""
			return moment(date).format("MM")
		},
		filterDay: function (date) {
			if (!date) return ""
			return moment(date).format("DD")
		},
	},
	methods: {
		redirectToShowPage() {
			this.$router.push({ name: "matter_show", params: { id: this.matter.id } })
		},
	},
	computed: {
		regularlySold() {
			if (this.matter.regularly_sold == true) {
				return "○"
			} else if (this.matter.regularly_sold == false) {
				return "×"
			} else {
				return ""
			}
		},
		contract() {
			if (this.matter.contract == true) {
				return "○"
			} else if (this.matter.contract == false) {
				return "×"
			} else {
				return ""
			}
		},
		maxHeight() {
			if (this.productTableHeight) {
				return {
					height: this.productTableHeight > 50 ? "50px" : `${this.productTableHeight}px`,
					display: "block",
				}
			} else {
				return null
			}
		},
		metaText() {
			return (data) => {
				const obj = this.matter.meta_data[`value${data.id}`]
				return obj ? obj : null
			}
		},
	},
}
</script>

<style scoped lang="scss">
th,
td {
	border-left: solid gray 1px;
}
td {
	white-space: pre-wrap;
}

.matter-record {
	td {
		line-height: 1.2;
		padding: 0.25rem 1rem;
		.matter-product-record {
			&:not(:first-child) {
				border-top: 1px solid whitesmoke;
			}
			td {
				padding: 0.25rem 0;
				border: none;
			}
		}
	}
}

.point-cell {
	margin-bottom: 0;
	word-break: break-all;
	white-space: pre-wrap;
}
</style>
